import { get } from '$fetch'


/**
 * 获取车辆配置参数
 * @param {String} cid 车源id
 */
export const getCarParams = (params = {}) => get('/lurker/api/car/params', params, {
  isLoading: false
})
